import { NgClass } from '@angular/common';
import {
  Component,
  computed,
  inject,
  input,
  model,
  output
} from '@angular/core';
import { Router } from '@angular/router';
import { PanelBeforeToggleEvent, PanelModule } from 'primeng/panel';

@Component({
    selector: 'app-main-nav-item',
    imports: [PanelModule, NgClass],
    templateUrl: './main-nav-item.component.html',
    styleUrl: './main-nav-item.component.scss'
})
export class MainNavItemComponent {
  private _router = inject(Router);

  public item = input.required<MainNavItem>();
  public isCollapsed = model.required<boolean>();
  public currentRoute = input.required<string>();

  public panelToggled = output<MainNavItemToggleEvent>();

  public hasNoSubItems = computed(() => !this.item().subNavItems?.length);

  public toggleNavItem(e: PanelBeforeToggleEvent): void {
    const hasSubItems = !!this.item().subNavItems?.length;
    if (!hasSubItems) {
      this._router.navigate(this.item().url);
    }

    this.panelToggled.emit({
      route: this.item().url.join('/'),
      title: this.item().title,
      isOpen: !!e.collapsed,
      hasSubNavItems: hasSubItems
    });
  }

  public navigate(): void {
    this._router.navigate(this.item().url);
  }

  public subNavigate(e: MouseEvent, urlSegment: string[]): void {
    e.stopPropagation();
    const nextUrl = this.item().url.concat(urlSegment);

    this._router.navigate(nextUrl);
  }
}

export type MainNavItem = {
  title: string;
  url: string[];
  icon: string;
  collapsed?: boolean;
  subNavItems?: SubMainNavItem[];
};

export type SubMainNavItem = Omit<MainNavItem, 'subNavItems'>;

export type MainNavItemToggleEvent = {
  title: MainNavItem['title'];
  isOpen: boolean;
  route: string;
  hasSubNavItems: boolean;
};
